import { type ReactNode } from 'react'

  type Props = {
    steps: ReactNode[]
  }
export default function StepsLayout ({ steps }: Props) {
  return (
    <div className='flex flex-col'>
      {steps.map((step, index) => (
        <div key={index} className='flex flex-row gap-4 group'>
          <div className='flex flex-col items-center'>
            <div className='w-[1px] h-2 bg-gray-200 rounded-lg group-first:w-0' />
            <div className='flex items-center justify-center my-2 h-5 w-5 shrink-0 rounded-full bg-thatch-200 border border-thatch-500 caption font-bold text-center'>
              {index + 1}
            </div>
            <div className='flex-1 w-[1px] bg-gray-200 rounded-lg group-last:w-0' />
          </div>
          <div className='flex-1 pb-4 group-last:pb-0'>
            {step}
          </div>
        </div>
      ))}
    </div>
  )
}
